import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "./utils/globalLibraries";
import ApiServiceLayer from "@/api/apiServiceLayer";
import router from "./router";
import Store from "./store/index";
import vuetify from "./plugins/vuetify";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import datePicker from '@alireza-ab/vue-persian-datepicker'

Vue.component('date-picker', datePicker)
const Path = require("./utils/applicationPath");

Vue.prototype.$ApiServiceLayer = ApiServiceLayer;
Vue.prototype.$PATH = Path;
Vue.prototype.$STORE = Store;
Vue.use(VueToast);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
